import "leaflet/dist/leaflet.css";
import { Fragment, useEffect, useState } from "react";
import L from "leaflet";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
  useMapEvents,
} from "react-leaflet";

import { coordDefault } from "helpers/constants";
import MDBox from "components/MDBox";
import { Typography } from "@mui/material";

interface CoordsProps {
  coords: [number, number];
}

interface Props {
  lat?: number;
  lng?: number;
  handlerSetCoords: (coords: LocationMarkerProps) => void;
}

interface LocationMarkerProps {
  lat: number;
  lng: number;
}

export default function MapsLeaflet({
  lat = coordDefault.latitude,
  lng = coordDefault.longitude,
  handlerSetCoords,
}: Props) {
  const [coords, setCoords] = useState<[number, number]>([lat, lng]);

  useEffect(() => {
    if (lat && lng) {
      setCoords([lat, lng]);
    }
  }, [lat, lng]);

  const LocationMarker = ({ lat, lng }: LocationMarkerProps) => {
    const [position, setPosition] = useState<any>({ lat, lng });

    const map = useMapEvents({
      click(e) {
        setPosition(e.latlng);
        handlerSetCoords({ lat: e.latlng.lat, lng: e.latlng.lng });
        map.flyTo(e.latlng, map.getZoom());
      },
    });

    return position === null ? null : (
      <Marker
        position={position}
        title="TNV Team Sports"
        icon={L.icon({
          iconUrl:
            "https://res.cloudinary.com/lesoftware/image/upload/v1707141509/tnvteamsport/dte2dllauy6yph3cld5i.webp",
          iconRetinaUrl:
            "https://res.cloudinary.com/lesoftware/image/upload/v1707141509/tnvteamsport/dte2dllauy6yph3cld5i.webp",
          iconSize: [32, 36],
          iconAnchor: [12.5, 41],
          popupAnchor: [0, -41],
        })}
      >
        <Popup>
          <p>Coordenadas:</p>
          <p>
            {position.lat}, {position.lng}
          </p>
        </Popup>
      </Marker>
    );
  };

  const ChangeMapView = ({ coords }: CoordsProps): null => {
    const map = useMap();
    map.setView(coords, map.getZoom());
    return null;
  };

  return (
    <Fragment>
      {/* HEADER */}
      <MDBox>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Define a localização do evento clicando no mapa para indicar o local
          exato.
        </Typography>
      </MDBox>
      {/* MAPS */}
      <MapContainer
        center={coords}
        zoom={13}
        style={{ height: "600px", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <ChangeMapView coords={coords} />
        <LocationMarker lat={lat} lng={lng} />
      </MapContainer>
    </Fragment>
  );
}
